<template>
  <div class="container">
    <div class="project-link wrap-shadow">
      <p class="title">{{this.$t('top.common.researchFiles')}}</p>
      <el-tree :data="tree" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      <!-- <ul class="article-link">
        <li v-for="(item ,index) in documentList" :key="index"> 
          <a v-if="item.url" :href="item.url" class="link" target="_blank">{{item.title}}</a>
          <a v-else href="javascript:void(0);" class="link" @click="showDetail(item)" >{{item.title}}</a>
        </li>
      </ul> -->
    </div>
    <div class="project-link wrap-shadow" style="height:220px;">
      <p class="title">{{principalInvestigator.title}}</p>
      <div class="resume-content">
        <p class="details check more-text" >
          {{principalInvestigator.msg}}
        </p>
        <el-link type="primary" class="more-btn" @click="showChenhuisheng(principalInvestigator)">{{$t('top.common.viewDetails')}}<i class="el-icon-view el-icon-arrow-right"></i></el-link>
      </div>
    </div>
    <div class="project-details wrap-shadow">
      <div class="details-content">
        <p class="title">{{principalInvestigatorSite.title}}</p>
        <div class="resume-content">
          <p class="details check more-text2" >
            {{principalInvestigatorSite.msg}}
          </p>
          <el-link v-if="store.lang === 'en_US'" type="primary" class="more-btn" @click="showcontent3(principalInvestigatorSite)">{{$t('top.common.viewDetails')}}<i class="el-icon-view el-icon-arrow-right"></i></el-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {store} from '@/store/index'
export default {
  data() {
    return {
      store,
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      documentList: [
        {
          title:this.$t('top.common.protocol'),
          children: [
            {
              title: 'V1.0',
              url: this.$t('top.file.protocolV1Url'),
            },
            {
              title: 'V2.0',
              url: this.$t('top.file.protocolV2Url'),
            },
            {
              title: this.$t('top.common.protocolPublished'),
              url: this.$t('top.file.protocolIJOSUrl'),
            },
          ]
        },
        {
          title:this.$t('top.common.plan'),
          hideInCh:true,
           children: [
            {
              title: 'V1.0',
              url: this.$t('top.file.planV1Url')
            },
            {
              title: 'V2.0',
              url: this.$t('top.file.planV2Url'),
            },
          ]
        },
        //  {
        //   title:this.$t("top.common.informedConset"),
        //   url: this.$t('top.file.informedConsetUrl')
        // },
        {
          title:this.$t('top.common.trialSteeringCommittee'),
          content: this.$t('top.file.trialSteeringCommittee')
        },
        {
          title:this.$t('top.common.institutionHumanResearchEthicsCommittee'),
          content:  this.$t('top.file.institutionHumanResearchEthicsCommittee')
        },
        {
          title:this.$t('top.common.dataMonitoringCommittee'),
          content: this.$t('top.file.dataMonitoringCommittee'),
          style:'width:100%;'
        },
        // {
        //   title:this.$t('top.common.outcomeCommittee'),
        //   content: this.$t('top.file.outcomeCommittee'),
        //   style:'width:100%;'
        // },
        // {
        //   title:'Original Protocol-EAST-V1',
        //   url: 'https://static.medsci.cn/product/medsci/pdf/originalProtocol.pdf'
        // },
        // {
        //   title:'Statistical Analysis Plan-EAST-V2',
        //   url: 'https://static.medsci.cn/product/medsci/pdf/statisticalAnalysis.pdf'
        // },
        // {
        //   title:'知情同意书',
        //   url: 'https://static.medsci.cn/product/medsci/pdf/informedConsent.pdf'
        // },
        // {
        //   title:'研究方案',
        //   url: 'https://static.medsci.cn/product/medsci/pdf/researchProposal.pdf'
        // },
      ],
      tree:[],
      principalInvestigator:{
        title:this.$t('top.common.principalInvestigator'),
        img: require('@/assets/image/chenhuisheng.png'),
        msg:this.$t('top.file.principalInvestigator')
      },
      principalInvestigatorSite:{
        title:this.$t('top.common.principalInvestigatorSite'),
        msg:this.$t('top.file.principalInvestigatorSiteContent')
      },
    }
  },
  created() {
    this.tree = this.documentList.filter(item => this.store.lang === 'zh_CN'?item.hideInCh?false:true:true)
  },
  methods: {
    handleNodeClick(data) {
      if (data.url) {
        window.open(data.url)
      } else {
        this.showDetail(data)
      }
      console.log(data);
    },
    showDetail(item) {
      const {title,content,style} = item
      const h = this.$createElement;
      let msg = h('p', null, [
            h('ul',  {class:'weiyuanhui-ul'}, 
								content.map((item) => [h('li',{class:'weiyuanhui-li',style:style},[
                  h('b',null,`${item.name}`),
                  item.position && h('p',null,`(${item.position})`),
                  h('p',null,`${item.organization}`)
                ])])
							)
          ])
      this.$alert(msg, title, {
        showConfirmButton:false,
        customClass:'message-box-weiyuan',
        // confirmButtonText: this.$t('top.common.confirm'),
      });
    },
    showChenhuisheng(item) {
      const {title} = item
      const h = this.$createElement;
      let msg = h('p', null, [
          h('img',{style:'width:218px;float:left;margin-right:10px;',attrs:{src:`${item.img}`}},null),
          h('p',null,`${item.msg}`)
          ])
      this.$alert(msg, title, {
        showConfirmButton:false,
        customClass:'message-box-pi',
        // confirmButtonText: this.$t('top.common.confirm'),
      });
    },
    showcontent3(item) {
      const {title} = item
      const h = this.$createElement;
      let msg = h('p', null, [
          h('p',null,`${item.msg}`)
          ])
      this.$alert(msg, title, {
        customClass:'message-box',
        showConfirmButton:false,
        // confirmButtonText: this.$t('top.common.confirm'),
      });
    }
  }
};
</script>
<style scoped>
.weiyuanhui-ul{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin:0;
  padding-left: 0;
  list-style: none;
}
.weiyuanhui-li{
  width: 194px;
  margin-bottom: 15px;
  padding:10px;
  text-align: center;
}
.weiyuanhui-li:first-child{
  width: 100%;
}
.container {
  margin-right: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y:auto;
}
.container::-webkit-scrollbar {
  display: none;
}
.wrap-shadow {
  background: #FFFFFF;
  box-shadow: 0 2px 20px 0 rgba(231,231,231,0.50);
  border-radius: 4px;
}
.project-link {
  width: 302px;
  margin-bottom: 12px;
  padding: 16px 25px 12px 25px;
  box-sizing: border-box;
  text-align: left;
  position: relative;
}
.project-details {
  width: 302px;
  flex:1;
  min-height: 170px;
  overflow: hidden;
}
.details-content {
  position: relative;
  height: 100%;
  padding: 16px 25px 12px 25px;
  box-sizing: border-box;
  text-align: left; 
  display: flex;
  flex-direction: column;
}
.resume-content {
  /* position: absolute;
  top:45px;
  left: 25px;
  right: 23px; */
  /* bottom: 14px; */
  overflow: hidden;
  flex: 1;
  /* overflow-y: auto; */
}
.resume-content::-webkit-scrollbar {
  display: none;
}
.title {
  padding: 0;
  margin: 0;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #373c48;
  margin-bottom: 6px;
}
.article-link {
  list-style:none;
  margin: 0;
  padding: 0;
  /* position: absolute; */
  top: 44px;
  bottom: 12px;
  overflow: hidden;
  overflow-y: auto;
}
.article-link::-webkit-scrollbar {
  display: none;
}
.link {
  cursor: pointer;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 24px;
}
.details {
  padding: 0;
  margin: 0;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 24px;
}
.check-details {
  color: #1890ff;
  margin-left: 10px;
  text-decoration: none;
}
.check-icon {
  padding-left: 5px;
  padding-right: 7px;
  color: #1890ff;
  font-size: 12px;
  opacity: 0.6;
  position: relative;
}
.check-icon::after {
  position: absolute;
  content: "";
  width: 5px;
  height: 5px;
  border-top: 1px solid #1890ff;
  border-right: 1px solid #1890ff;
  transform: rotate(45deg);
  left: 1px;
  top: 6px;
}
.check-icon:hover {
  opacity: 1;
}
.more-text{
	overflow: hidden;
  height: 120px;
  word-break: break-all;          
  text-overflow: ellipsis;         
  display: -webkit-box;            
  text-overflow: ellipsis;         
  -webkit-box-orient: vertical;  
  -webkit-line-clamp: 5; 
}
.more-text2{
	overflow: hidden;
  /* max-height: 200px; */
  text-align: justify;
  height: calc(100% - 24px);
  word-break: break-all;          
  text-overflow: ellipsis;         
  display: -webkit-box;            
  text-overflow: ellipsis;         
  -webkit-box-orient: vertical;  
  /* -webkit-line-clamp: 6;  */
}
</style>
